// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-page-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.settings-page-container .settings-modal-header {
  position: relative;
  justify-content: center;
  flex-shrink: 0;
}

.settings-page-container .back-button {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.settings-page-container .settings-page-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.ignored-users-search-section {
  flex-shrink: 0;
  padding: 20px;
}

.ignored-users-info-text {
  color: rgba(215, 154, 0, 1);
  font-size: 14px;
  line-height: 1.5;
  margin: 16px 0 0 0;
  border-radius: 8px;
}

.ignored-users-search-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  color: #666;
  font-size: 14px;
}

.ignored-users-search-loading .spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #e0e0e0;
  border-top-color: #0066cc;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.ignored-users-search-results {
  margin-top: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  max-height: 300px;
  overflow-y: auto;
}

.ignored-users-search-result {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid #f0f0f0;
}

.ignored-users-search-result:last-child {
  border-bottom: none;
}

.ignored-users-search-result:hover {
  background-color: #f5f5f5;
}

.ignored-users-search-result:focus {
  outline: 2px solid #0066cc;
  outline-offset: -2px;
  background-color: #f5f5f5;
}

.ignored-users-search-result-info {
  flex: 1;
  min-width: 0;
}

.ignored-users-search-result-name {
  font-weight: 500;
  color: #000;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ignored-users-search-result-id {
  color: #666;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ignored-users-add-icon {
  font-size: 20px;
  color: var(--netsfere-red);
  flex-shrink: 0;
}

.ignored-users-no-results {
  padding: 24px 16px;
  text-align: center;
  color: #666;
  font-size: 14px;
}

.ignored-users-list-section {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  border-top: 1px solid rgba(216, 216, 216, 1);
}

.ignored-users-list-title {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  margin: 0 0 16px 0;
}

.ignored-users-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  color: #999;
  text-align: center;
}

.ignored-users-empty ion-icon {
  font-size: 64px;
  color: #ddd;
  margin-bottom: 16px;
}

.ignored-users-empty p {
  font-size: 16px;
  font-weight: 500;
  color: #666;
  margin: 0 0 8px 0;
}

.ignored-users-empty span {
  font-size: 14px;
  color: #999;
}

.ignored-users-list {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.ignored-user-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  background-color: white;
  border-bottom: 1px solid rgba(151, 151, 151, 0.5);
}

.ignored-user-item:last-child {
  border-bottom: none;
}

.ignored-user-info {
  display: flex;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.ignored-user-name {
  font-size: 14px;
  font-weight: 400;
  color: rgba(106, 106, 106, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}

.ignored-user-remove-button {
  padding: 8px;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--netsfere-red);
  transition: background-color 0.2s;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ignored-user-remove-button:hover {
  background-color: rgba(220, 53, 69, 0.1);
}

.ignored-user-remove-button:focus {
  outline: 2px solid #dc3545;
  outline-offset: 2px;
}

.ignored-user-remove-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ignored-user-remove-button ion-icon {
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal/IgnoredUsersPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".settings-page-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.settings-page-container .settings-modal-header {\n  position: relative;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.settings-page-container .back-button {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.settings-page-container .settings-page-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n}\n\n.ignored-users-search-section {\n  flex-shrink: 0;\n  padding: 20px;\n}\n\n.ignored-users-info-text {\n  color: rgba(215, 154, 0, 1);\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 16px 0 0 0;\n  border-radius: 8px;\n}\n\n.ignored-users-search-loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n  color: #666;\n  font-size: 14px;\n}\n\n.ignored-users-search-loading .spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #e0e0e0;\n  border-top-color: #0066cc;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.ignored-users-search-results {\n  margin-top: 12px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.ignored-users-search-result {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.ignored-users-search-result:last-child {\n  border-bottom: none;\n}\n\n.ignored-users-search-result:hover {\n  background-color: #f5f5f5;\n}\n\n.ignored-users-search-result:focus {\n  outline: 2px solid #0066cc;\n  outline-offset: -2px;\n  background-color: #f5f5f5;\n}\n\n.ignored-users-search-result-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.ignored-users-search-result-name {\n  font-weight: 500;\n  color: #000;\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ignored-users-search-result-id {\n  color: #666;\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ignored-users-add-icon {\n  font-size: 20px;\n  color: var(--netsfere-red);\n  flex-shrink: 0;\n}\n\n.ignored-users-no-results {\n  padding: 24px 16px;\n  text-align: center;\n  color: #666;\n  font-size: 14px;\n}\n\n.ignored-users-list-section {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  border-top: 1px solid rgba(216, 216, 216, 1);\n}\n\n.ignored-users-list-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #000;\n  margin: 0 0 16px 0;\n}\n\n.ignored-users-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  color: #999;\n  text-align: center;\n}\n\n.ignored-users-empty ion-icon {\n  font-size: 64px;\n  color: #ddd;\n  margin-bottom: 16px;\n}\n\n.ignored-users-empty p {\n  font-size: 16px;\n  font-weight: 500;\n  color: #666;\n  margin: 0 0 8px 0;\n}\n\n.ignored-users-empty span {\n  font-size: 14px;\n  color: #999;\n}\n\n.ignored-users-list {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.ignored-user-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  background-color: white;\n  border-bottom: 1px solid rgba(151, 151, 151, 0.5);\n}\n\n.ignored-user-item:last-child {\n  border-bottom: none;\n}\n\n.ignored-user-info {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.ignored-user-name {\n  font-size: 14px;\n  font-weight: 400;\n  color: rgba(106, 106, 106, 1);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  min-width: 0;\n}\n\n.ignored-user-remove-button {\n  padding: 8px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--netsfere-red);\n  transition: background-color 0.2s;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ignored-user-remove-button:hover {\n  background-color: rgba(220, 53, 69, 0.1);\n}\n\n.ignored-user-remove-button:focus {\n  outline: 2px solid #dc3545;\n  outline-offset: 2px;\n}\n\n.ignored-user-remove-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ignored-user-remove-button ion-icon {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
